import styled from 'styled-components';
import { BREAKPOINTS } from '../common/breakpoints';

export const BodyContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 0.75rem;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Row = styled.div`
  display: flex;
  gap: 0.5rem;

  > * {
    min-width: 38px;
  }
`;

export const TicketInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;

  @media (max-width: ${BREAKPOINTS.MOBILE_NARROW}) {
    grid-template-columns: 1fr;
  }
`;
